<template>
  <el-row :getter="20">
    <el-col :span="6">
      <el-tree
        :data="govTree"
        :props="govTreeProps"
      ></el-tree>
    </el-col>
    <el-col :span="18">
      <h2>机构信息</h2>
      <el-form
        :model="orgMessage"
        size="medium"
        label-width="100px"
      >
        <el-form-item label="管理区域" prop="adminArea">
          <el-cascader :props="props" style="width:100%;"></el-cascader>
        </el-form-item>
        <el-form-item label="机构名称" prop="orgName">
          <el-input v-model="orgMessage.orgName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简称">
          <el-input
            v-model="orgMessage.shortName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="orgMessage.address" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium">确 定</el-button
        >
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { getCity } from '@/api/city'
export default {
  data() {
    return {
      govTreeProps: {
        children: 'children',
        label: 'label'
      },
      orgMessage: {
        orgName: '',
        adminArea: 0,
        address: '',
        shortName: ''
      },
      props: {
        // 获取管理区域城市tree
        emitPath: false,
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node
          let valueArr = []
          if (value) {
            valueArr = value.split(',')
          }
          getCity({
            code: valueArr[0] || '100000000'
          }).then(res => {
            const nodes = Array.from(res.data)
              .map(item => ({
                label: item.name,
                value: item.code + ',' + item.id,
                code: item.code,
                // 判断最后一层
                leaf: item.type > 3
              }))
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)
          })
        }
      },
      govTree: [
        {
          label: '沂水县农机局',
          children: [
            {
              label: '镇级别',
              children: [
                {
                  label: '村级别'
                }
              ]
            }
          ]
        },
        {
          label: '沂水县农机局2',
          children: [
            {
              label: '镇级别2-1',
              children: [
                {
                  label: '村级别2-1-1'
                }
              ]
            },
            {
              label: '镇级别22-2',
              children: [
                {
                  label: '村级别2-2-1'
                }
              ]
            }
          ]
        },
        {
          label: '沂水县农机局 3',
          children: [
            {
              label: '二级 3-1',
              children: [
                {
                  label: '三级 3-1-1'
                }
              ]
            },
            {
              label: '二级 3-2',
              children: [
                {
                  label: '三级 3-2-1'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  watch: {
    checkList(val) {
      console.log(val)
    }
  },
  methods: {
    filterTag(value, row) {
      return row.role === value
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    }
  }
}
</script>
